import { atom } from 'recoil'

export const growthShrimpDateTableFilterState = atom<Date | undefined>({
  key: 'growthShrimpDateTableFilterState',
  default: undefined,
})

export const selectedGrowthShrimpIdState = atom<number | undefined>({
  key: 'selectedGrowthShrimpIdState',
  default: undefined,
})

export const growthShrimpStartDateTableFilterState = atom<Date | undefined>({
  key: 'growthShrimpStartDateTableFilterState',
  default: undefined,
})

export const growthShrimpEndDateTableFilterState = atom<Date | undefined>({
  key: 'growthShrimpEndDateTableFilterState',
  default: undefined,
})
